import React from 'react';
import {
  Card, CardBody, Col, Progress,
} from 'reactstrap';
import TrendingUpIcon from 'mdi-react/TrendingUpIcon';
import { useQuery } from 'react-query';
import axios from 'axios';
import { useCookies } from 'react-cookie';

const TotalBookings = () => {
  const [cookies, setCookie] = useCookies(['tranAuthToken']);
  const
    {
      data,
      isLoading,
      isFetching,
      isError,
    } = useQuery('stats', () => axios.get('https://tran-backend-zd8g.onrender.com/api/admin/stats', {
      headers: {
        Authorization: `Bearer ${cookies.tranAuthToken}`,
      },
    }));

    

  return (
    <Col md={12} xl={3} lg={6} xs={12}>
      <Card>
        <CardBody className="dashboard__booking-card">
          <div className="dashboard__booking-total-container">
            <h5 className="dashboard__booking-total-title dashboard__booking-total-title--green">
              {!isLoading && !isFetching && !isError && data.data.data.consignors}
            </h5>
            <TrendingUpIcon className="dashboard__trend-icon" />
          </div>
          <h5 className="dashboard__booking-total-description">Total Consignors</h5>
          {/* <div className="progress-wrap progress-wrap--small progress-wrap--lime-gradient progress-wrap--rounded">
          <p className="dashboard__booking-card-progress-label progress__label">32%</p>
          <Progress value={32} />
        </div> */}
        </CardBody>
      </Card>
    </Col>
  );
};
export default TotalBookings;
